import {
  FORMULARIO_GLOBAL_QUESTION_TYPES,
  QUESTION_TYPES_WITH_OPTIONS,
  normalizeFormularioGlobalQuestionType,
} from 'src/componentes/formulario-global/FormularioGlobalQuestionTypes';

const toNumber = (value) =>
  Number.isFinite(Number(value)) ? Number(value) : 0;

const SORT_FORM_ORDER = 'ordem-formulario';

const SORT_HIGHEST_PERCENTAGE = 'maior-percentual';

const SORT_HIGHEST_QUANTITY = 'maior-quantidade';

const CHART_PALETTE = [
  { color: '#1d7789', className: 'tw:text-[#1d7789]' },
  { color: '#5aa9b5', className: 'tw:text-[#5aa9b5]' },
  { color: '#8fd1d7', className: 'tw:text-[#8fd1d7]' },
  { color: '#f2b01e', className: 'tw:text-[#f2b01e]' },
  { color: '#e9824d', className: 'tw:text-[#e9824d]' },
  { color: '#8b6fc1', className: 'tw:text-[#8b6fc1]' },
  { color: '#d65b9e', className: 'tw:text-[#d65b9e]' },
  { color: '#5f8fc9', className: 'tw:text-[#5f8fc9]' },
  { color: '#66a85c', className: 'tw:text-[#66a85c]' },
  { color: '#c86161', className: 'tw:text-[#c86161]' },
  { color: '#7b8794', className: 'tw:text-[#7b8794]' },
];

const normalizeSearchText = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const getQuestionFormOrder = (pergunta) => toNumber(pergunta.ordemFormulario);

const compareQuestionsByFormOrder = (a, b) => {
  const rootOrderA = a.secao
    ? toNumber(a.secao.ordem)
    : getQuestionFormOrder(a);
  const rootOrderB = b.secao
    ? toNumber(b.secao.ordem)
    : getQuestionFormOrder(b);

  return (
    rootOrderA - rootOrderB || getQuestionFormOrder(a) - getQuestionFormOrder(b)
  );
};

const getOptionColor = (opcao, index) => {
  return opcao.corGrafico || CHART_PALETTE[index % CHART_PALETTE.length].color;
};

const getOptionColorClassName = (opcao, index) =>
  opcao.corGraficoClassName ||
  CHART_PALETTE[index % CHART_PALETTE.length].className;

const compararOrdemOpcoes = (a, b) =>
  toNumber(a.ordem ?? a.posicao) - toNumber(b.ordem ?? b.posicao) ||
  toNumber(a.posicao) - toNumber(b.posicao);

const ordenarOpcoes = (opcoes, ordenacao) => {
  return [...opcoes]
    .sort(compararOrdemOpcoes)
    .map((opcao, index) => {
      const cor = CHART_PALETTE[index % CHART_PALETTE.length];
      return {
        ...opcao,
        corGrafico: cor.color,
        corGraficoClassName: cor.className,
      };
    })
    .sort((a, b) => {
      if (ordenacao === SORT_HIGHEST_PERCENTAGE) {
        return (
          toNumber(b.percentual) - toNumber(a.percentual) ||
          compararOrdemOpcoes(a, b)
        );
      }
      if (ordenacao === SORT_HIGHEST_QUANTITY) {
        return (
          toNumber(b.quantidade) - toNumber(a.quantidade) ||
          compararOrdemOpcoes(a, b)
        );
      }
      return compararOrdemOpcoes(a, b);
    });
};

const EMPTY_STATE_CLASS_NAME =
  'tw:px-4 tw:py-9 tw:text-center tw:text-[#98a2b3]';

const obterPerguntasComOpcoes = (dados) =>
  (dados?.perguntas || [])
    .filter((pergunta) =>
      [
        ...QUESTION_TYPES_WITH_OPTIONS,
        FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO,
      ].includes(normalizeFormularioGlobalQuestionType(pergunta.tipoPergunta))
    )
    .sort(compareQuestionsByFormOrder);

const organizarPerguntasPorSecao = (perguntas) =>
  perguntas.reduce((grupos, pergunta) => {
    const chave = pergunta.secao
      ? `secao-${pergunta.secao.id}`
      : `pergunta-${pergunta.perguntaId}`;
    let grupo = grupos.find((item) => item.chave === chave);

    if (!grupo) {
      grupo = {
        chave,
        secao: pergunta.secao,
        perguntas: [],
      };
      grupos.push(grupo);
    }

    grupo.perguntas.push(pergunta);
    return grupos;
  }, []);

export {
  toNumber,
  SORT_FORM_ORDER,
  SORT_HIGHEST_PERCENTAGE,
  SORT_HIGHEST_QUANTITY,
  normalizeSearchText,
  getQuestionFormOrder,
  compareQuestionsByFormOrder,
  getOptionColor,
  getOptionColorClassName,
  compararOrdemOpcoes,
  ordenarOpcoes,
  EMPTY_STATE_CLASS_NAME,
  obterPerguntasComOpcoes,
  organizarPerguntasPorSecao,
};
